interface Props {
    array_fechas: Date[];
}

const getEveryDayBetween2Dates = ({ array_fechas }: Props) => {
    const [startDate, endDate] = array_fechas;

    const date = new Date(startDate.getTime());

    const dates = [];

    while (date <= endDate) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }

    return dates;
};

export default getEveryDayBetween2Dates;
